import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { getJson } from '../helpers/RequestsHelper'

import AirtableKeysInput from './apps/AirtableKeysInput';
import SendGridKeysInput from './apps/SendGridKeysInput';
import TwilioKeysInput from './apps/TwilioKeysInput';
import TogglToken from './apps/TogglTokenKeysInput';
import AlphaVantage from './apps/AlphaVantageKeysInput';
import ConfirmationPopup from './ConfirmationPopup'
import Slingshot from './apps/SlingshotKeysInput';
import DeFiPulseKeysInput from './apps/DeFiPulseKeysInput';
import APIKeysInput from './apps/APIKeysInput';
import SMTPInput from './apps/SMTPInput';

class AccountConnectComponent extends Component {

    state = {
        loading: true,
        connected: false
    }

    constructor() {
        super();
        this.addNewClick = this.addNewClick.bind(this);
        this.connectClick = this.connectClick.bind(this);
        this.disconnectClick = this.disconnectClick.bind(this);
        this.callAPI = this.callAPI.bind(this)
    }

    componentDidMount() {
        if (!this.props.new) {
            this.callAPI();
        } else {
            this.setState({ loading: false, account: this.props.account, connected: this.props.account.connected })
        }
    }

    // static getDerivedStateFromProps(props, state) {
    //     state.account = props.account

    //     return state
    // }

    async callAPI() {
        var path = process.env.REACT_APP_SERVER_BASE_URL + "/" + this.props.account.type +
            "/login?redirect=" + encodeURI(window.location.pathname + (window.location.search ? window.location.search : "")) +
            "&accountId=" + this.props.account.accountId

        if (this.props.new) {
            path += "&new=1"
        }

        if (this.props.requiredScope) {
            path += "&requiredScope=" + this.props.requiredScope
        }

        const json = await getJson(path);
        if (json === "fail") {
            //TODO: [Error]
        } else {
            this.setState({ loading: false, account: json, connected: json.connected })
            this.props.account.connected = json.connected
        }
        this.props.onUpdate(this.props.account)
    }

    addNewClick = async () => {
        if (this.props.account.type === "airtable" || this.props.account.type === "sendgrid" || this.props.account.type === "toggltrack" || this.props.account.type === "alphavantage" || this.props.account.type === "slingshot" || this.props.account.type === "twilio" || this.props.account.type === "defipulse" || this.props.account.type === "cryptowatch" || this.props.account.type === "finnhub" || this.props.account.type === "sendinblue" || this.props.account.type === "mongodbatlas" || this.props.account.type === "smtp") {
            this.setState({ input: true, newAccount: true })
        } else {
            var path = process.env.REACT_APP_SERVER_BASE_URL + "/" + this.props.account.type +
                "/login?redirect=" + encodeURI(window.location.pathname + (window.location.search ? window.location.search : "")) +
                "&accountId=" + this.props.account.accountId + "&new=1"

            if (this.props.requiredScope) {
                path += "&requiredScope=" + this.props.requiredScope
            }
            const json = await getJson(path);

            window.location = json.loginUrl;
        }
        return false
    }

    connectClick() {
        if (this.props.account.type === "airtable" || this.props.account.type === "sendgrid" || this.props.account.type === "toggltrack" || this.props.account.type === "alphavantage" || this.props.account.type === "slingshot" || this.props.account.type === "twilio" || this.props.account.type === "defipulse" || this.props.account.type === "cryptowatch" || this.props.account.type === "finnhub" || this.props.account.type === "sendinblue" || this.props.account.type === "mongodbatlas" || this.props.account.type === "smtp") {
            this.setState({ input: true, newAccount: false })
        } else {
            window.location = this.state.account.loginUrl;
        }
    }

    disconnectClick = async () => {
        this.setState({ showDisconnectWarning: false, loading: true })
        //this.props.account.connected = false
        //this.props.onUpdate(this.props.account)
        await getJson(process.env.REACT_APP_SERVER_BASE_URL + "/" + this.props.account.type + "/disconnect?accountId=" + this.props.account.accountId)
        // if (json.connected === false) {
        //     this.setState({ account:json })
        // }
        await this.callAPI()
        //TODO: [Error]
    }

    render() {

        const { t } = this.props;

        let connectButton;
        if (this.state.loading) {
            connectButton = <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        } else if (this.props.new) {
            connectButton = <div><button onClick={this.addNewClick} className="submit-btn-2"><i className="fa fa-plus"></i> Add new</button></div>
        } else if (this.state.connected) {
            if (this.props.showDisconnect) {
                connectButton = <div>
                    <button onClick={() => this.setState({ showDisconnectWarning: true })}
                        className="submit-btn-2"
                    ><i className="fas fa-unlink"></i> Disconnect</button>
                    <ConfirmationPopup show={this.state.showDisconnectWarning}
                        title={t("warning")}
                        onConfirm={this.disconnectClick}
                        onHide={() => this.setState({ showDisconnectWarning: false })}
                        text={t("disconnect_warning")}
                        buttonText={t("Disconnect")} />
                </div>
            } else {
                connectButton = <></>
            }
        } else {
            connectButton = <div><button onClick={this.connectClick} className="submit-btn-2" ><i className="fas fa-link"></i> Connect</button></div>
        }

        if (this.state.input) {
            const accountId = this.state.newAccount ? undefined : this.props.account.accountId
            if (this.props.account.type === "airtable") {
                return <div style={{ "paddingLeft": "32px" }}><AirtableKeysInput accountId={accountId} /></div>
            } else if (this.props.account.type === "sendgrid") {
                return <div style={{ "paddingLeft": "32px" }}><SendGridKeysInput accountId={accountId} /></div>
            } else if (this.props.account.type === "twilio") {
                return <div style={{ "paddingLeft": "32px" }}><TwilioKeysInput accountId={accountId} /></div>
            } else if (this.props.account.type === "toggltrack") {
                return <div style={{ "paddingLeft": "32px" }}><TogglToken accountId={accountId} /></div>
            } else if (this.props.account.type === "alphavantage") {
                return <div style={{ "paddingLeft": "32px" }}><AlphaVantage accountId={accountId} /></div>
            } else if (this.props.account.type === "slingshot") {
                return <div style={{ "paddingLeft": "32px" }}><Slingshot accountId={accountId} /></div>
            } else if (this.props.account.type === "defipulse") {
                return <div style={{ "paddingLeft": "32px" }}><DeFiPulseKeysInput accountId={accountId} /></div>
            } else if (this.props.account.type === "cryptowatch") {
                return <div style={{ "paddingLeft": "32px" }}><APIKeysInput accountType={this.props.account.type} accountId={accountId} /></div>
            } else if (this.props.account.type === "finnhub") {
                return <div style={{ "paddingLeft": "32px" }}><APIKeysInput accountType={this.props.account.type} accountId={accountId} /></div>
            } else if (this.props.account.type === "sendinblue") {
                return <div style={{ "paddingLeft": "32px" }}><APIKeysInput accountType={this.props.account.type} accountId={accountId} /></div>
            } else if (this.props.account.type === "mongodbatlas") {
                return <div style={{ "paddingLeft": "32px" }}><APIKeysInput accountType={this.props.account.type} accountId={accountId} hasAPIId={true} /></div>
            } else if (this.props.account.type === "smtp") {
                return <div style={{ "paddingLeft": "32px" }}><SMTPInput accountType={this.props.account.type} accountId={accountId} hasAPIId={true} /></div>
            }

        } else {
            return connectButton
        }
    }
}

export default withTranslation()(AccountConnectComponent)
